import {type Theme as ModernFamlyTheme} from '@famly/mf_theme';
import {getWhitelabel} from 'web-app/shared/white-labeling-helpers';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import NewLookTheme from './new-look';
import EspiraTheme from './espira';
import KidoTheme from './kido';
import GrandirUKTheme from './grandiruk';
import NuffieldHealthTheme from './nuffieldhealth';
import BrightHorizonsTheme from './bright-horizons';
import KindredTheme from './kindred';
import MonkeyPuzzleTheme from './monkeypuzzle';
import NFamilyClubTheme from './nfamilyclub';
import KinderzimmerUKTheme from './kinderzimmeruk';
import CpcTreehouseTheme from './cpc-treehouse';
import CpcOrchardsTheme from './cpc-orchards';
import BusybeesTheme from './busybees';
import BBMontessoriTheme from './bbmontessori';
import BBOdysseyTheme from './bbodyssey';
import BaseTheme from './base';

/**
 * @deprecated Use color enum
 */

export const colorKeys = [
    'primary',
    'secondary',
    'active',
    'accent1',
    'accent2',
    'accent3',
    'analogue1',
    'analogue2',
    'analogue3',
    'text',
    'blackScrim',
    'textSecondary',
    'textDisabled',
    'invertedText',
    'invertedTextSecondary',
    'invertedTextDisabled',
    'whiteSecondary',
    'whiteDisabled',
    'delimiter',
    'backgroundHover',
];

export const currentTheme = () => {
    const whitelabel = getWhitelabel();

    switch (whitelabel) {
        case 'espira':
            return EspiraTheme;
        case 'kido':
            return KidoTheme;
        case 'brighthorizons':
            return BrightHorizonsTheme;
        case 'kindred':
            return KindredTheme;
        case 'monkeypuzzle':
            return MonkeyPuzzleTheme;
        case 'nfamilyclub':
            return NFamilyClubTheme;
        case 'grandiruk':
            return GrandirUKTheme;
        case 'nuffieldhealth':
            return NuffieldHealthTheme;
        case 'kinderzimmeruk':
            return KinderzimmerUKTheme;
        case 'cpctreehouse':
            return CpcTreehouseTheme;
        case 'cpcorchards':
            return CpcOrchardsTheme;
        case 'busybees':
            return BusybeesTheme;
        case 'bbmontessori':
            return BBMontessoriTheme;
        case 'bbodyssey':
            return BBOdysseyTheme;
        case 'famly':
        case null:
            return NewLookTheme;
        default:
            return BaseTheme;
    }
};

export const getCurrentModernFamlyTheme = (): ModernFamlyTheme => {
    const whitelabel = getWhitelabel();
    const theme = currentTheme();

    if (!hasValue(whitelabel)) {
        return NewLookTheme.mf;
    }
    return theme.mf;
};

export default currentTheme;

export {NewLookTheme};
